/* eslint-disable no-useless-escape */
export const validatePassword = (input: string) => {
  return !input || input.length < 6;
};

export const validateEmail = (input: string) => {
  const reg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  const result = reg.test(input);
  const b1 = input === '';
  const error = !result && !b1;

  return error;
};

export const validateVideoUrl = (input: string) => {
  try {
    const url = new URL(input);
    return !(url.protocol === 'http:' || url.protocol === 'https:');
  } catch (e) {
    return true;
  }
};
